import { LicensingAgencyStatus } from '@/@types/generated'
import { register } from './enum'

export const LicensingAgencyStatusTextColor: Record<
  LicensingAgencyStatus,
  string
> = {
  [LicensingAgencyStatus.DRAFT]: 'text-gray-500',
  [LicensingAgencyStatus.UNDER_REVIEW]: 'text-purple-400',
  [LicensingAgencyStatus.ACTIVE]: 'text-green-500',
  [LicensingAgencyStatus.REJECTED]: 'text-red-500',
  [LicensingAgencyStatus.SUSPENDED]: 'text-yellow-500',
  [LicensingAgencyStatus.REVOKED]: 'text-red-500',
}

export const LicensingAgencyStatusLabels: Record<
  LicensingAgencyStatus,
  string
> = {
  [LicensingAgencyStatus.DRAFT]: 'In Progress',
  [LicensingAgencyStatus.UNDER_REVIEW]: 'Pending',
  [LicensingAgencyStatus.ACTIVE]: 'Approved',
  [LicensingAgencyStatus.REJECTED]: 'Rejected',
  [LicensingAgencyStatus.SUSPENDED]: 'Suspended',
  [LicensingAgencyStatus.REVOKED]: 'Revoked',
}

register<LicensingAgencyStatus>(LicensingAgencyStatus, (v) => {
  if (!v) return '\u2014'
  return LicensingAgencyStatusLabels[v]
})
